import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconTableDataOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M24 9v13.5c0 .732-.672 1.5-1.5 1.5h-21C.672 24 0 23.232 0 22.5v-21C0 .768.672 0 1.5 0h21c.828 0 1.5.768 1.5 1.5V9M12.75 7.5h9.75v-6h-9.75zM1.5 7.5h9.75v-6H1.5zm0 7.5h9.75V9H1.5zm0 7.5h9.75v-6H1.5zm11.25 0h9.75v-6h-9.75zm0-7.5h9.75V9h-9.75z" /></svg>
);
